export function resolveSource(isMobileApp, platformId) {
  if (!isMobileApp) {
    return 'kz';
  }
  switch (platformId) {
    case 2:
    case 3:
      return 'app';
    default:
      return 'kz';
  }
}
